<template>
  <div class="d-flex align-center justify-center fill-height w-100">
    <v-progress-circular color="primary" size="120" width="5" indeterminate="disable-shrink">
      <v-img class="animated-image" width="100" height="100" :src="utils.getImgUrl('logo.png')"></v-img>
    </v-progress-circular>
  </div>
</template>

<script setup>
</script>

<style scoped>
.animated-image {
  animation: rotate-opacity 3s linear infinite;
}

@keyframes rotate-opacity {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: rotate(180deg);
  }
  100% {
    opacity: 0;
    transform: rotate(360deg);
  }
}
</style>
